import { render } from "./complainTable.vue?vue&type=template&id=3f0bac84&scoped=true"
import script from "./complainTable.vue?vue&type=script&lang=js"
export * from "./complainTable.vue?vue&type=script&lang=js"

import "./complainTable.vue?vue&type=style&index=0&id=3f0bac84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0bac84"]])

export default __exports__